export class Query {
  protected name!: string;

  /**
   * Your API_KEY
   */
  public key!: string;

  public output: 'json' | 'xml' = 'json';

  protected constructor(initialParams: Partial<any>) {
    Object.assign(this, initialParams);
  }

  public get apiName(): string {
    return this.name;
  }

  public toQuery(): string {
    return this.objectToQuery(this);
  }

  protected transformValue(key: string, value: any): string {
    if (key === 'query') {
      return (value as string).replace(' ', '+');
    }

    // @ts-ignore
    if (key === 'location' && typeof this[key] !== 'string') {
      return [value.latitude, value.longitude].join(',');
    }

    return value;
  }

  protected objectToQuery(obj: object): string {
    return Object.keys(obj)
      .reduce<string[]>((acc, key) => {
        // @ts-ignore
        if (obj[key]) {
          // @ts-ignore
          if (typeof obj[key] === 'object') {
            // @ts-ignore
            if (Object.keys(obj[key]).length > 0) {
              // @ts-ignore
              acc.push(this.objectToQuery(obj[key]));
            }
          } else {
            // @ts-ignore
            acc.push(`${key}=${this.transformValue(key, obj[key])}`);
          }
        }
        return acc;
      }, [])
      .join('&');
  }
}
